import { Button as ButtonBase } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import styled from 'styled-components';
import { SUCESS_COLOR, XMEI_SECONDARY_COLOR } from '../../../../consts/common';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1``;

export const Row = styled.div`
  display: flex;

  justify-content: space-between;
`;

export const InfoTitle = styled.span`
  font-size: 1.2em;
  font-weight: bold;
`;

export const InfoValue = styled.span`
  font-size: 1.2em;
`;

export const AssinaturaStatus = styled(InfoValue)`
  color: ${({ isActive }) => (isActive ? SUCESS_COLOR : XMEI_SECONDARY_COLOR)};
`;

export const SignatureCanceledCard = styled(Alert).attrs({
  severity: 'warning',
})`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const SignatureText = styled.h3``;

export const Button = styled(ButtonBase)`
  margin-top: 20px;
`;
